// Initialize Google Analytics
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize gtag
window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}

// Initialize GA4
export const initializeAnalytics = () => {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
};

// Track page views
export const trackPageView = (page) => {
  gtag('event', 'page_view', {
    page_title: page,
    page_location: window.location.href,
    page_path: window.location.pathname
  });
};

// Track events
export const trackEvent = (category, action, label, value) => {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};

// Set user properties
export const setUserProperties = (properties) => {
  gtag('set', 'user_properties', properties);
};

// Track user engagement
export const trackEngagement = (type, details) => {
  gtag('event', 'user_engagement', {
    engagement_type: type,
    ...details
  });
};

// Track daily devotional view
export const trackDailyDevotionalView = (devotionalId) => {
  gtag('event', 'view_devotional', {
    devotional_id: devotionalId
  });
};

// Track user registration
export const trackUserRegistration = (method) => {
  gtag('event', 'sign_up', {
    method: method
  });
};

// Track email subscription
export const trackEmailSubscription = (status) => {
  gtag('event', 'email_subscription', {
    status: status
  });
};

// Track notification permission
export const trackNotificationPermission = (status) => {
  gtag('event', 'notification_permission', {
    status: status
  });
};

// Track notification interaction
export const trackNotificationInteraction = (type, notificationId) => {
  gtag('event', 'notification_interaction', {
    interaction_type: type,
    notification_id: notificationId
  });
}; 